// extracted by mini-css-extract-plugin
export default {"srOnly":"oMiG+","couponContainer":"+jTHq","headerTitle":"Z0nw3","headerSubtitle":"Xwr6I","couponText":"_9KwUH"};